import React, { useState, useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";

import {Box} from '@mui/material';

import NavBar from "./layout/NavBar";
import HandleProfile from "./pages/admin/HanldeProfile";
import Container from "./layout/Container";
import { SidebarProvider } from "./layout/SidebarContext";
import { SIDEBAR_WIDTH } from "./layout/layoutMetrics";


import {
  HanldeProfile,
  CreateWellnessTopic,
  CreateWellnessAttribute,
  CreateWellnessChoice,
  ChangeWellnessTopic,
  ChangeWellnessAttribute,
  ChangeWellnessChoice,
  ClientsReport,
  AdvisorsReport,
  ManageSystemPrompts,
  ChatSessionsList,
  ChatSessionDetail,
  AdminClientsDashboards,
  ManageUsers,
  ChangeUserInfo,
  ReportTracePage,
  InjectTablePage,
  AccessControlScreen,
  PlatformUsersScreen,
  TenantMetadataScreen,
  SharedDatasetsScreen,
} from "./pages/admin";

import { ProtectedRoute } from "./components/AccessControl";

import SelfServeOnboardingWizard from "./pages/onboarding/SelfServeOnboardingWizard";

import {
  Activity,
  AMLForm,
  ContactLocation,
  IDInformation,
  PersonalInformation
} from "./pages/AML-Information";


import {
  DataAnalytics,
  NlqChatWorkspace,
  DataReports,
  DataHome,
  ChartSelector,
  CensusDashboard,
  CensusTractsVisualization,
  LlmReportAgent,
  FederationWorkspace,
  DashboardList,
  DashboardView
} from "./dataanalytics";

import history from "./HistoryExport"
import { federationEnabled } from "./Api";

const AuthedRoutes = (mainProps) => {
  // Use state to track the current path and update on route changes
  const [currentPath, setCurrentPath] = useState(history.location.pathname);

  useEffect(() => {
    // Update currentPath whenever the route changes
    const unlisten = history.listen((location) => {
      setCurrentPath(location.pathname);
      console.log('Route changed to:', location.pathname); //DEBUG
    });

    // Cleanup listener on unmount
    return () => unlisten();
  }, []);

  console.log('Current path:', currentPath); //DEBUG

  // Define paths that should not show the menu
  const noMenuPaths = [
    '/onboarding/personalinformation',
  ];


  console.log(mainProps.navBarEnabled);
  console.log(noMenuPaths.includes(currentPath));
  const showMenu = !noMenuPaths.includes(currentPath) && mainProps.navBarEnabled;

// console.log(mainProps.navBarEnabled) //DEBUG
  return (
    <Router history={history}>
      <SidebarProvider>
      {mainProps.navBarEnabled && <NavBar {...mainProps} showMenuButton={showMenu} />}
      {/*
        The sidebar renders its own `position: fixed` drawers, so it takes no
        space in flow. The content column therefore offsets itself by exactly
        the drawer width — and ONLY at md and up, where the permanent drawer
        actually exists. Previously the gutter was reserved at every breakpoint
        (16.7% on xs, 33.3% on sm) even though the drawer is hidden below md,
        which threw away up to a third of the screen on phones and tablets.
      */}
      <Box sx={{ display: 'flex', width: '100%', position: 'relative' }}>
        {showMenu && <HandleProfile {...mainProps} asMenu />}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            width: '100%',
            marginLeft: showMenu ? { xs: 0, md: `${SIDEBAR_WIDTH}px` } : 0,
          }}
        >
          <Container>
            <Switch>
            
              {/* <Route exact path="/" component={Home} /> */}

              <Route
                exact
                strict
                path="/handle_profile"
                render={(props) =>
                  React.createElement(HanldeProfile, { ...props, ...mainProps })}
              />

              <Route 
                exact 
                path="/onboarding/personalinformation" 
                render={(props) => 
                React.createElement(PersonalInformation, { ...props, ...mainProps })} 
              />
              <Route 
                exact 
                path="/account/generalinfo" 
                render={(props) => 
                React.createElement(AMLForm, { ...props, ...mainProps })} 
              />
              <Route 
                exact 
                path="/account/idinfo" 
                render={(props) => 
                React.createElement(IDInformation, { ...props, ...mainProps })} />
              <Route 
                exact 
                path="/account/contactinfo" 
                render={(props) => 
                React.createElement(ContactLocation, { ...props, ...mainProps })} />
              <Route 
                exact 
                path="/account/activityinfo" 
                render={(props) => 
                React.createElement(Activity, { ...props, ...mainProps })} />  
              <Route
                exact
                path="/onboarding/self-serve"
                render={(props) =>
                React.createElement(SelfServeOnboardingWizard, { ...props, ...mainProps })}
              />
              {/* Admin routes — gated client-side (server re-checks). See Phase 8. */}
              <ProtectedRoute exact path="/admin/wellness_structure/new_topic"
                component={CreateWellnessTopic} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/wellness_structure/new_attribute"
                component={CreateWellnessAttribute} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/wellness_structure/new_answer"
                component={CreateWellnessChoice} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/wellness_structure/change_topics"
                component={ChangeWellnessTopic} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/wellness_structure/change_attributes"
                component={ChangeWellnessAttribute} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/wellness_structure/change_answers"
                component={ChangeWellnessChoice} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/reports_consumers"
                component={ClientsReport} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/reports_advisors"
                component={AdvisorsReport} mainProps={mainProps} roleFallback="ADMIN" />
              <ProtectedRoute exact path="/admin/llm_system_prompts"
                component={ManageSystemPrompts} mainProps={mainProps} requireRoot
                anyOf={['PLATFORM_PROMPT_VIEW']}
                deniedMessage="The global LLM system prompts are managed by platform (ROOT) administrators only." />
              <ProtectedRoute exact path="/admin/llm_sessions"
                component={ChatSessionsList} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['CHAT_SESSION_VIEW_ALL']} />
              <ProtectedRoute exact path="/admin/llm-sessions/detail"
                component={ChatSessionDetail} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['CHAT_SESSION_VIEW_ALL']} />
              <ProtectedRoute exact path="/admin/clients_dashboard"
                component={AdminClientsDashboards} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['CLIENT_DASHBOARD_VIEW']} />
              <ProtectedRoute exact path="/admin/manage_users"
                component={ManageUsers} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['USER_MANAGE', 'USER_VIEW']} />
              <ProtectedRoute exact path="/admin/change_user_info"
                component={ChangeUserInfo} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['USER_MANAGE']} />
              <ProtectedRoute exact path="/admin/report_traces"
                component={ReportTracePage} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['REPORT_TRACE_VIEW']} />
              <ProtectedRoute exact path="/admin/inject_table"
                component={InjectTablePage} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['TABLE_INJECT']} />

              {/* Phase 8 admin screens */}
              <ProtectedRoute exact path="/admin/access_control"
                component={AccessControlScreen} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['ROLE_MANAGE', 'USER_MANAGE', 'PLATFORM_ROLE_MANAGE', 'PLATFORM_USER_MANAGE']} />
              <ProtectedRoute exact path="/admin/platform_users"
                component={PlatformUsersScreen} mainProps={mainProps} requireRoot
                anyOf={['PLATFORM_USER_MANAGE']}
                deniedMessage="The cross-tenant users view is available to platform (ROOT) administrators only." />
              <ProtectedRoute exact path="/admin/tenant_metadata"
                component={TenantMetadataScreen} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['TENANT_METADATA_MANAGE']} />
              <ProtectedRoute exact path="/admin/shared_datasets"
                component={SharedDatasetsScreen} mainProps={mainProps} requireRoot
                anyOf={['PLATFORM_DATASET_GRANT']}
                deniedMessage="Shared dataset access is managed by platform (ROOT) administrators only." />

              {/* Data Analytics */}
              <Route 
                exact 
                path="/data_analytics/home" 
                render={(props) => 
                React.createElement(DataHome, { ...props, ...mainProps })} 
              />

              <Route
                exact
                path="/data_analytics/nlq_chat"
                render={(props) =>
                React.createElement(NlqChatWorkspace, { ...props, ...mainProps })}
              />

              <Route 
                exact 
                path="/data_analytics/reports" 
                render={(props) => 
                React.createElement(DataReports, { ...props, ...mainProps })} 
              />

              <Route 
                exact 
                path="/data_analytics/analytics" 
                render={(props) => 
                React.createElement(DataAnalytics, { ...props, ...mainProps })} 
              />

              <Route 
                exact 
                path="/data_analytics/client_metrics" 
                render={(props) => 
                React.createElement(ChartSelector, { ...props, ...mainProps })} 
              />
            
              <Route
                exact
                path="/data_analytics/census"
                render={(props) =>
                  React.createElement(CensusDashboard, { ...props, ...mainProps })
                }
              />
              <Route
                exact
                path="/data_analytics/census_tracts"
                render={(props) =>
                  React.createElement(CensusTractsVisualization, { ...props, ...mainProps })
                }
              />
              <Route
                exact
                path="/data_analytics/llm_report_agent"
                render={(props) =>
                  React.createElement(LlmReportAgent, { ...props, ...mainProps })}
              />

              {/* NL dashboards — gated on DASHBOARD_VIEW (server re-checks every call). */}
              <ProtectedRoute exact path="/data_analytics/dashboards"
                component={DashboardList} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['DASHBOARD_VIEW']} />
              <ProtectedRoute exact path="/data_analytics/dashboards/:id"
                component={DashboardView} mainProps={mainProps} roleFallback="ADMIN"
                anyOf={['DASHBOARD_VIEW']} />

              {/* Cross-cloud client data federation — sibling under Data Analytics.
                  Gated on FEDERATION_MANAGE (server re-checks); ADMIN fallback.
                  Only registered when the REACT_APP_FEDERATION_ENABLED build flag is "true". */}
              {federationEnabled && (
                <ProtectedRoute exact path="/data_analytics/federation"
                  component={FederationWorkspace} mainProps={mainProps} roleFallback="ADMIN"
                  anyOf={['FEDERATION_MANAGE']} />
              )}
            </Switch>
          </Container>
        </Box>
      </Box>
      </SidebarProvider>
    </Router>
  );
}

export default AuthedRoutes;
